import { NextResponse } from 'next/server'

const contentType = "image/svg+xml"
const cacheControl = "public, max-age=0, must-revalidate"
const buffer = Buffer.from("PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+CiAgPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMTIiIGZpbGw9IiNCODc0MkUiLz4KICA8cGF0aCBkPSJNMjAgMTZoMjh2OGgtMjB2NmgxN3Y4aC0xN3YxMGgtOFYxNnoiIGZpbGw9IiNGQkY4RjAiLz4KPC9zdmc+Cg==", 'base64')

export function GET() {
    return new NextResponse(buffer, {
        headers: {
            'Content-Type': contentType,
            'Cache-Control': cacheControl,
        },
    })
}

export const dynamic = 'force-static'
